import React, { useState } from 'react';
import { isNil, propEq, replace, isNotNil } from 'ramda';
import { Button } from 'antd';
import { AppstoreAddOutlined } from '@ant-design/icons';
import ModalCreateVersion from '../pages/offer/editOffer/ModalCreateVersion';
import ModalDuplicateOffer from './ModalDuplicateOffer';

const CreateVersion = ({
  versionId,
  userCanCreateVersion,
  redirect,
  version,
  offerId,
  userId
}) => {
  const [showModal, setShowModal] = useState(false);

  const [itemId, setItemId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [errorDuplicateOffer, setErrorDuplicateOffer] = useState(false);

  const {
    isLastMajor,
    isLastMinor
  } = version;
  const canCreateVersion = isLastMinor || (isLastMajor && isLastMinor);

  if (!userCanCreateVersion || isNil(version) || !propEq('release', 'status', version)) {
    return null;
  }

  const onHide = () => setShowModal(false);
  const openStatusModal = () => setIsOpen(true);
  const onError = () => setErrorDuplicateOffer(true);

  return (
    <>
      <ModalCreateVersion
        versionId={versionId}
        isLastMinor={isLastMinor}
        isLastMajor={isLastMajor}
        visible={showModal}
        onHide={onHide}
        openStatusModal={openStatusModal}
        onError={onError}
        setItemId={setItemId}
      />

      <ModalDuplicateOffer
        open={isOpen}
        setIsOpen={setIsOpen}
        error={errorDuplicateOffer}
        redirectTo={isNotNil(itemId) ? replace(':itemId', itemId)(redirect) : null}
        userId={userId}
        offerId={offerId}
      />

      {canCreateVersion && (
        <Button
          size="large"
          type="primary"
          icon={<AppstoreAddOutlined />}
          onClick={() => setShowModal(true)}
        >
          Créer une nouvelle version
        </Button>
      )}
    </>
  );
};

export default CreateVersion;
